import { render, staticRenderFns } from "./ThemeTour.vue?vue&type=template&id=76594358"
import script from "./ThemeTour.vue?vue&type=script&lang=js"
export * from "./ThemeTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports